import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import ConfirmationModal from '@ubeya/shared-web/components/ConfirmationModal';

const CONFIRMATION_MODAL_Z_INDEX = 130;

const ResolveConfirmBody = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

const HelpDeskTicketActionsModals = ({
  showCloseConfirm,
  onCloseConfirmDismiss,
  onCloseConfirm,
  showResolveConfirm,
  onResolveConfirmDismiss,
  onResolveConfirm,
  resolutionTimeoutHours
}) => (
  <>
    {showCloseConfirm && (
      <ConfirmationModal
        title="help_desk_close_ticket"
        body="help_desk_close_ticket_confirm"
        onClose={onCloseConfirmDismiss}
        onConfirm={onCloseConfirm}
        zIndex={CONFIRMATION_MODAL_Z_INDEX}
        usePortal
      />
    )}

    {showResolveConfirm && (
      <ConfirmationModal
        title="help_desk_resolve_ticket"
        onClose={onResolveConfirmDismiss}
        onConfirm={onResolveConfirm}
        confirmText="help_desk_resolve_ticket"
        usePortal
        zIndex={200}>
        <ResolveConfirmBody>
          <Trans
            i18nKey="help_desk_resolve_confirm_body"
            components={{ br: <br />, strong: <strong /> }}
            values={{ hours: resolutionTimeoutHours }}
          />
        </ResolveConfirmBody>
      </ConfirmationModal>
    )}
  </>
);

export default HelpDeskTicketActionsModals;
